import { useEffect } from 'react';

import { useSubmitCompanyViewed } from '../useSubmitCompanyViewed';
import { setLastVisitedStockForMiniValuator } from '@/pages/Narrative/utils/storage';

interface UseRecentlyViewedCompanyArgs {
  uniqueSymbol?: string;
  enabled: boolean;
  canonicalUrl?: string;
}

export default function useRecentlyViewedCompany({
  uniqueSymbol,
  enabled,
  canonicalUrl,
}: UseRecentlyViewedCompanyArgs) {
  const { mutate: submitCompanyViewed } = useSubmitCompanyViewed();

  useEffect(() => {
    if (enabled && uniqueSymbol) {
      submitCompanyViewed({ uniqueSymbol });
    }
  }, [submitCompanyViewed, enabled, uniqueSymbol]);

  useEffect(() => {
    if (canonicalUrl) {
      setLastVisitedStockForMiniValuator(canonicalUrl);
    }
  }, [canonicalUrl]);
}
